export default function isVirtualKeyboardShown() {
    return window.scrollY > 0;
}